// extracted by mini-css-extract-plugin
module.exports = {"preliminaryTitle":"_uW","tooltip":"_uX","propertyContainer":"_uY","infoIcon":"_uZ","big":"_u0","gray":"_u1","title":"_u2"};